// extracted by mini-css-extract-plugin
module.exports = {"datePicker":"date_datePicker__2CfMV","pointer":"date_pointer__2nidC"};